import { rangeValue } from "./general";

export const validateTimeRefreshOrderRange = (value) => {
    if (Number(value) < 0 || Number(value) > 600) {
      return "osfc.messages.validation.timeRefreshOrderRange";
    }
  };

// Stored value is in seconds
export const POPUP_NOTIFICATION_DURATION_MIN = 1; // 1 sec
export const POPUP_NOTIFICATION_DURATION_MAX = 60 * 30; // 30 min

export const validatePopupNotificationDurationRange = rangeValue(
    POPUP_NOTIFICATION_DURATION_MIN,
    POPUP_NOTIFICATION_DURATION_MAX,
    "osfc.messages.validation.popupNotificationDurationRange"
);
